import { useMemo } from 'react';

export default function RoleSummary({ spots }) {
	const roles = useMemo(() => {
		if (spots == null) return [];
		return Object.values(spots.map(s => s.role).filter(x => x != null).reduce((tot, role) => ({ ...tot, [role.id]: role }), {}));
	}, [ spots ]);

	const countBySpot = useMemo(() => {
		if (spots == null) return [];
		const counters = {};
		spots.forEach(spot => {
			const roleId = spot?.role?.id;
			if (roleId == null) return;
			if (counters[roleId] == null) counters[roleId] = 0;
			counters[roleId]++;
		});
		return Object.entries(counters).sort((a, b) => {
			if (a[1] == b[1]) {
				if (a[0] > b[0]) {
					return -1;
				} else if (a[0] == b[0]) {
					return 0;
				} else {
					return 1;
				}
			} else {
				return b[1] - a[1];
			}
		});
	}, [ spots ]);

	if (spots == null) return null;
	return <table className="table table-fw">
		<thead>
			<tr>
				<th>Type</th>
				<th>Aantal</th>
			</tr>
		</thead>
		<tbody>
			{countBySpot.map(([ roleId, amount ], idx) => {
				const role = roles.find(r => r.id == roleId);
				return <tr key={roleId}>
					<td style={{ background: role.colorCode }}>
						{role.shortCode}
					</td>
					<td className="tbl-align-right">
						{amount}
					</td>
				</tr>;
			})}
		</tbody>
	</table>;
}